import type { ApiKeyScope } from '@/services/apiKeys'

export const MCP_DOCS_URL = `${import.meta.env.VITE_API_DOCS_URL}/mcp`
export const PUBLIC_API_DOCS_URL = `${import.meta.env.VITE_API_DOCS_URL}/api`

export const API_KEY_SCOPES: { value: ApiKeyScope; label: string }[] = [
  { value: 'read', label: 'Read' },
  { value: 'write', label: 'Write (includes read)' },
]

/** Short labels for the scope pills on an issued key — the picker spells the rest out. */
export const API_KEY_SCOPE_PILL_LABELS: Record<ApiKeyScope, string> = {
  read: 'Read',
  write: 'Write',
}
